import approveIcon from "@assets/SVG/approve.svg";
import deleteIcon from "@assets/SVG/delete.svg";
import rejectIcon from "@assets/SVG/reject.svg";

import { Icon } from "@iconify/react";
import { Alert, Button, Input, Modal, Select } from "antd";
import _ from "lodash";
import { useEffect, useState } from "react";
const { Option } = Select;

interface SubmitConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (reviewNotes: string, status?: string, attenderName?: string) => Promise<void> | void;
  type: "submit" | "save" | "delete" | "back" | "approve" | "reject" | "submitWithNoReview" | "deleteWithNoReview";
  draftCount?: number;
  moduleName?: string;
  defaultReviewNotes?: string;
  confirmationText?: string;
}
export default function ConfirmationModal({
  open,
  onClose,
  onSubmit,
  type,
  draftCount,
  moduleName,
  defaultReviewNotes,
  confirmationText,
}: SubmitConfirmModalProps) {
  const reviewNotesInfo = reviewNotesInfos[type];

  const [reviewNotes, setReviewNotes] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setReviewNotes(defaultReviewNotes);
  }, [defaultReviewNotes]);

  function onCancelHandler() {
    onClose();
  }

  function onReviewNotesChangeHandler(e: React.ChangeEvent<HTMLTextAreaElement>) {
    if (e.target.value.length > 0 && error) {
      setError(false);
    }
    setReviewNotes(e.target.value);
  }
  async function onSubmitHandler() {
    if (reviewNotesInfo && reviewNotes.trim().length === 0) {
      setError(true);
      return;
    }

    setLoading(true);
    try {
      await onSubmit(reviewNotes);
    } catch (err) {
      // TODO: handle error
    } finally {
      setLoading(false);
      setReviewNotes("");
      onClose();
    }
  }

  return (
    <Modal
      open={open}
      maskClosable={true}
      onCancel={onCancelHandler}
      centered
      width={420}
      zIndex={2000}
      footer={
        <div className="flex items-center w-full justify-center -mt-6 mb-4 text-center">
          <Button
            type="default"
            onClick={onCancelHandler}
          >
            No, Cancel
          </Button>
          <Button
            type="primary"
            onClick={onSubmitHandler}
          >
            {loading && (
              <Icon
                icon={"mdi:loading"}
                width="12"
                height="12"
                className="animate-spin mr-1"
              />
            )}
            Yes, Proceed
          </Button>
        </div>
      }
    >
      <div className="text-center flex flex-col items-center">
        <img
          src={
            type === "delete" || type === "back" || type === "deleteWithNoReview"
              ? deleteIcon
              : type === "reject"
                ? rejectIcon
                : approveIcon
          }
          alt="Modal Icon"
          className={`${type === "back" ? "h-12" : "h-16"} mb-4`}
        />
        <h2
          className={`${type === "back" ? "text-md" : "text-xl"} font-semibold  mb-4 ${type === "delete" || type === "back" || type === "reject" || type === "deleteWithNoReview" ? "text-[#F26486]" : "text-[#00C247]"}`}
        >
          {type === "back"
            ? "Going back will not save your Content"
            : type === "submitWithNoReview"
              ? "Submit"
              : type === "deleteWithNoReview"
                ? "Delete"
                : `${_.capitalize(type)} ?`}
        </h2>
        {confirmationText && <p className="text-sm text-[#51505D] mb-3 font-medium">{confirmationText}</p>}
        {type !== "delete" && type !== "deleteWithNoReview" && (
          <p className="text-xs text-[#51505D]">
            {type === "approve" || type === "reject" ? `Are you sure to ${type} request?` : "Do you wish to proceed?"}
          </p>
        )}
        {reviewNotesInfo && (
          <>
            <div className="mt-2 mb-4">
              {
                <Alert
                  message={<p className="text-xs mb-0 text-[#51505D]">{reviewNotesInfo}</p>}
                  type="warning"
                  showIcon
                  className="w-100 "
                />
              }
            </div>
            <Input.TextArea
              className="w-full text-center"
              placeholder={type === "reject" ? "Reason" : "Review Notes"}
              maxLength={5000}
              minLength={3}
              name="reviewNotes"
              value={reviewNotes}
              onChange={onReviewNotesChangeHandler}
            />
            <div className="w-100 text-left">
              {error && (
                <p className="text-xs text-[#FF3333] mt-1">
                  {type === "reject" ? "Reason" : "Review Notes"} is required
                </p>
              )}
              <br />
            </div>
          </>
        )}
        {draftCount > 0 && (
          <div className="mt-2 mb-4">
            {/* {
                  <Alert
                message={<p className="text-xs mb-0 text-[#51505D]">There are <strong>{draftCount}</strong> draft entries available in this module. Approving this record will automatically remove all existing drafts.</p>}
                type="warning"
                showIcon
                className="w-100 "
              />
              } */}
            <div className="mb-2 text-orange-400 text-lg">Warning</div>
            <div>
              Approving this request will discard the existing{" "}
              <strong className="text-[#712B90] text-base">{draftCount}</strong> Drafts in{" "}
              {moduleName ? moduleName : "this Module"}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

const reviewNotesInfos = {
  submit: `Please fill out the Review Notes before sending. This helps the Reviewer understand your
            submission better and provide more accurate Review Process.`,
  delete: `This action will send a deletion request to the approver.
            Please fill out the Review Notes before sending.
            The content will only be deleted once the request has been approved.
  Do you wish to proceed?`,
  submitWithNoReview: "",
  deleteWithNoReview: "",
  save: "",
  back: "",
  approve: "",
  reject: `Please fill out reason before rejecting.
    This helps the Requestor understand your decision better.`,
};
